























































































import { listFactory } from '@/main/pages';
import { Partner } from '@/modules/kartoteka/partner';
import { Pracovnik } from '@/modules/administrace/pracovnik';
import { Ozakazka } from '@/modules/servis/ozakazka';
import { Zakazka } from '@/modules/servis/zakazka';

import { types } from './store/types';
import { store } from './store/list';
import { NAME } from './constants';

export default listFactory(NAME, store).extend({
	components: {
		PartnerSelect: Partner.components.Select,
		PracovnikSelect: Pracovnik.components.Select,
		OzakazkaSelect: Ozakazka.components.Select,
	},
	data() {
		return {
			objectName: Zakazka.name,
		};
	},
	computed: {
		mutationsMappers(): Record<string, string> {
			return {
				partner: `${this.storeUri}/${types.mutations.ZAKAZKA_FILTER_ZAKAZNIK_SELECT_MAPPER}`,
				ozakazka: `${this.storeUri}/${types.mutations.ZAKAZKA_FILTER_OZAKAZKA_SELECT_MAPPER}`,
				pojistovna: `${this.storeUri}/${types.mutations.ZAKAZKA_FILTER_POJISTOVNA_SELECT_MAPPER}`,
				leazingZakaznik: `${this.storeUri}/${types.mutations.ZAKAZKA_FILTER_LEAZING_ZAKAZNIK_SELECT_MAPPER}`,
				smluvniPartner: `${this.storeUri}/${types.mutations.ZAKAZKA_FILTER_SMLUNI_PARTNER_SELECT_MAPPER}`,
				zadavatel: `${this.storeUri}/${types.mutations.ZAKAZKA_FILTER_ZADAVATEL_SELECT_MAPPER}`,
			};
		},
	},
	created() {
		this.titleDetail = this.Localize('Archiv');
	},
	methods: {
		PojistovnaIdPrpChange() {
			if (!this.PojistovnaIdPrp) {
				this.PojistovnaId = null;
				this.PojistovnaIdText = null;
			}
		},
		PojistCisPuPrpChange() {
			if (!this.PojistCisPuPrp) {
				this.PojistCisPu = null;
			}
		},
		PojistCisPuChange() {
			this.PojistCisPuPrp = !this.PojistCisPu ? null : true;
		},
		PojistCisExtzaklikvPrpChange() {
			if (!this.PojistCisExtzaklikvPrp) {
				this.PojistCisExtzaklikv = null;
			}
		},
		PojistCisExtzaklikvChange() {
			this.PojistCisExtzaklikvPrp = !this.PojistCisExtzaklikv ? null : true;
		},
		LeasCisSchvalPrpChange() {
			if (!this.LeasCisSchvalPrp) {
				this.LeasCisSchval = null;
			}
		},
		LeasCisSchvalChange() {
			this.LeasCisSchvalPrp = !this.LeasCisSchval ? null : true;
		},
	},
});
